// utils/utmHelper.ts
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';

import { LPBaseURL, UTMContent } from './enum';

export type UTMParams = {
  baseUrl?: LPBaseURL; // Usar o enum BaseURL
  utmContent: UTMContent; // Usar o enum UTMContent
  pathname: string;
};

export const generateUTMLink = ({
  baseUrl = LPBaseURL.PRIME,
  utmContent,
  pathname,
}: UTMParams): string => {
  const url = new URL(baseUrl);
  url.searchParams.set('utm_source', 'site');
  url.searchParams.set('utm_content', utmContent);

  if (typeof window === 'undefined') return url.toString(); // Proteção para SSR

  const utmMedium =
    pathname === '/'
      ? 'home'
      : pathname.replace(/\//g, '-').replace(/^-|-$/g, ''); // Remove a / do path

  url.searchParams.set('utm_medium', utmMedium);

  return url.toString();
};

export const useSaveUTMParams = () => {
  const router = useRouter();

  const {
    utm_source = '',
    utm_medium = '',
    utm_campaign = '',
    utm_term = '',
    utm_content = '',
  } = router.query;

  useEffect(() => {
    if (utm_source || utm_medium || utm_campaign || utm_term || utm_content) {
      const userTracking = Cookies.get('user_tracking')
        ? JSON.parse(Cookies.get('user_tracking'))
        : {};

      Cookies.set(
        'user_tracking',
        JSON.stringify({
          utm_source,
          utm_medium,
          utm_campaign,
          utm_term,
          utm_content,
          ...userTracking, // Mantém os valores antigos
        }),
        { domain: 'maisretorno.com' }
      );
    }
  }, [utm_source, utm_medium, utm_campaign, utm_term, utm_content]);
};
